import { lazy } from 'react';
const ListenCommentCourseRoutes = [
    {
        label: '评课页',
        key: 'listen-comment-course-evaluate',
        path: '/listen-comment-course-evaluate',
        show: true,
        element: lazy(() => import('@/page/ListenCommentCourse/Evaluate'))
    },
    {
        label: '受邀页',
        key: 'listen-comment-course-invitation',
        path: '/listen-comment-course-invitation',
        show: true,
        element: lazy(() => import('@/page/ListenCommentCourse/Invitation'))
    },
    {
        label: '听评课添加/编辑',
        key: 'lesson-assess',
        path: '/lesson-assess',
        show: true,
        element: lazy(() => import('@/page/LessonAssess/initiate'))
    },
    {
        label: '评课报告',
        key: 'listen-comment-course-report',
        path: '/listen-comment-course-report',
        show: true,
        element: lazy(() => import('@/page/LessonAssess/lessonReport'))
    }
];
export default ListenCommentCourseRoutes;
